require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./gruppo-di-ricerca-matteo-iannello.json") })
        }
      }, "path---gruppo-di-ricerca-matteo-iannello");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---gruppo-di-ricerca-matteo-iannello!./.cache/json/gruppo-di-ricerca-matteo-iannello.json
// module id = 662
// module chunks = 231608221292675